// eslint-disable-next-line no-restricted-imports
import { isFedRamp } from '@atlassian/atl-context';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { fg } from '@confluence/feature-gating';

export const isContentTypeEnabledInCurrentEnv = (
	contentType: 'whiteboard' | 'database' | 'slide' | null | undefined,
): boolean => {
	if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
		// Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
		if (fg('use_frontend_feature_encoding_sdk')) {
			const featureKeyMap: Record<string, string> = {
				database: 'confluence-databases',
				slide: 'confluence-slides',
				whiteboard: 'confluence-whiteboards',
			};
			return isFeatureEnabled('confluence', featureKeyMap[contentType]);
		}
		return !isFedRamp();
	}

	return true;
};
